module.exports = __webpack_public_path__ + "img/windows版.1f41fd1e.png";